import { Outlet, Navigate } from "react-router-dom";

const PrivateRoutes2 = ({ token }) => {
  let temp = localStorage.getItem("resturent_token");
  return token || temp ? <Outlet /> : <Navigate to="/restaurant/login" />;
};

export default PrivateRoutes2;
